import request from '@/utils/sap-request'

// 根据object_id查询单据
export const getOrderDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_so_by_id',
    method: 'POST',
    data
  })
}

// 销售订单查询
export const getOrderList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_so',
    method: 'POST',
    data
  })
}

// 销售公关团购订单查询
export const getGroupOrderList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_so_ggtg',
    method: 'POST',
    data
  })
}

// 销售公关团购订单明细查询
export const getGroupOrderDetailList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_so_ggtg_mx',
    method: 'POST',
    data
  })
}

// 销售订单明细查询
export const getOrderDetailList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_so_detail',
    method: 'POST',
    data
  })
}

// 配额酒：更新销售计划项目行信息
export const apiQuotaUpdateSaleItem = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_u_data_quota',
    method: 'POST',
    data
  })
}

// 非配额酒：更新销售计划项目行信息
export const apiNoQuotaUpdateSaleItem = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_u_data_other',
    method: 'POST',
    data
  })
}

// 公关团购：更新销售计划项目行信息
export const apiGGTGUpdateSaleItem = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_u_data_ggtg',
    method: 'POST',
    data
  })
}

// 终端团购：更新销售计划项目行信息
export const apiZDTGUpdateSaleItem = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_u_data_zdtg',
    method: 'POST',
    data
  })
}

// 氛围陈列：更新销售计划项目行信息
export const apiFWCLUpdateSaleItem = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_u_data_other',
    method: 'POST',
    data
  })
}

// 氛围陈列：保存
export const apiFWCLSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_fwcl',
    method: 'POST',
    data
  })
}

// 终端团购：保存
export const apiZDTGSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_zdtg',
    method: 'POST',
    data
  })
}

// 公关团购：保存
export const apiGGTGSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_ggtg',
    method: 'POST',
    data
  })
}

// 非配额酒：保存
export const apiNoQuotaSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_no_quota',
    method: 'POST',
    data
  })
}

// 配额酒：保存
export const apiQuotaSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_quota',
    method: 'POST',
    data
  })
}

// 批条酒：更新销售计划项目行信息
export const apiPTaUpdateSaleItem = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_u_data_other',
    method: 'POST',
    data
  })
}

// 批条酒：保存销售计划项目行信息
export const apiPTSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_pitiao',
    method: 'POST',
    data
  })
}

// 获取祝福语
export const apiGreetings = (data) => {
  return request({
    url: 'sap/bc/ztpm/oprord/pengmainfo',
    method: 'POST',
    data
  })
}

// 获取计划类型
export const apiPlanTypeList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plan_type_ovs',
    method: 'POST',
    data
  })
}

// 待关闭销售订单明细查询
export const apiOrderCloseList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_sc_so',
    method: 'POST',
    data
  })
}

// 待关闭销售订单 关闭
export const apiOrderClose = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/sc_so_close',
    method: 'POST',
    data
  })
}

// 订单解锁
export const apiOrderLock = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/onactionunlock',
    method: 'POST',
    data
  })
}

// 创建后续
export const apiCreateFollow = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_follow_up',
    method: 'POST',
    data
  })
}

// 确认收货
export const apiGGTGConfirm = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_ggtg_confirm',
    method: 'POST',
    data
  })
}

// 销售订单货款校验
export const soHkCheck = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/so_hk_check',
    method: 'POST',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/sap/order-sap.js